// extracted by mini-css-extract-plugin
export var wrapper = "styles-module__wrapper___pXKrx";
export var reverse = "styles-module__reverse____2Ch0";
export var label = "styles-module__label___Je85f";
export var itoggle = "styles-module__itoggle___KU1De";
export var input = "styles-module__input___Sx74o";